import React, { FunctionComponent, ReactNode } from 'react';

import { OwnerType } from '../../../types/__generated__';
import PAGE_TYPES from '../../constants/pageTypes';
import { usePageMeta } from '../../hooks';
import { useProduct } from '../../hooks/page/product/useProduct';
import { useCharity } from '../../hooks/page/useCharity';
import useBasePageQuery from '../../hooks/useBasePageQuery';

const PageOwnerTitle: FunctionComponent = () => {
  const { data: basePageData } = useBasePageQuery();
  const { name, url } = useOwner();

  const { title, summary } = basePageData?.page ?? {};

  return (
    <>
      {name && (
        <Owner as={url ? 'a' : 'span'} href={url}>
          {name}
        </Owner>
      )}
      {title && (
        <h1
          data-qa="page-owner-title"
          style={summary ? {} : { marginBottom: 0 }}
        >
          {title}
        </h1>
      )}
      {summary && (
        <p
          data-qa="page-owner-summary"
          className="jg-text--light jg-pages-teams-charitysummary jg-space-mbn"
        >
          {capitalizeFirstLetter(summary)}
        </p>
      )}
    </>
  );
};

export default PageOwnerTitle;

const capitalizeFirstLetter = (input: string) =>
  `${input[0].toUpperCase()}${input.slice(1)}`;

interface OwnerProps {
  children: ReactNode;
  as: 'span' | 'a';
  href?: string;
}

function Owner({ as, children, ...props }: OwnerProps) {
  const Component = as;

  return (
    <Component {...props} className="jg-h5 jg-space-mbn jg-hero__owner-title">
      {children}
    </Component>
  );
}

function useOwner() {
  const { data: basePageData } = useBasePageQuery();
  const { pageType } = usePageMeta();
  const { name: charityName, profilePageUrl } = useCharity();
  const { ownerType } = useProduct();

  switch (true) {
    case pageType === PAGE_TYPES.FUNDRAISING ||
      (pageType === PAGE_TYPES.ONE_PAGE && ownerType === OwnerType.Individual):
      return {
        name: basePageData?.page?.owner?.name,
      };
    case pageType === PAGE_TYPES.CAMPAIGN ||
      (pageType === PAGE_TYPES.ONE_PAGE &&
        ownerType === OwnerType.Organisation):
      return {
        name: charityName,
        url: profilePageUrl,
      };
    default:
      return {};
  }
}
